package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class StudentAttendanceResponse(
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("recorded_by_staff_id") val recordedByStaffId: String? = null,
    @SerialName("attendance_date") val attendanceDate: String? = null,
    val status: String? = null,
    val remarks: String? = null,
    val id: String? = null,
    @SerialName("created_at") val createdAt: String? = null
)
